import { ActionStore, ModalStore } from '@stores/models/store';
import * as Reducers from '@stores/reducers/Reducers';

const initialState: ModalStore = {
  title: '',
  component: null,
  show: false,
};

const reducer = (
  state = initialState,
  action: ActionStore<ModalStore>,
): ModalStore => {
  switch (action.type) {
    case Reducers.OPEN_MODAL:
      return { ...state, ...action.payload, show: true };
    case Reducers.CLOSE_MODAL:
      return { ...state, show: false, component: null };
    default:
      return state;
  }
};

export default reducer;
